import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

export function VendorTable({ vendors, canModify = false }) {
  const total = vendors.length;

  return (
    <>
      <div className="manage-table-container">
        <table className="manage-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Vendor Name</th>
              <th>Category</th>
              <th>Subcategory</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {total === 0 ? (
              <tr>
                <td
                  colSpan={5}
                  className="py-10 text-center text-[var(--muted-foreground)]"
                >
                  {canModify
                    ? 'No vendors yet. Add your first vendor to get started.'
                    : 'No vendors yet.'}
                </td>
              </tr>
            ) : (
              vendors.map((vendor) => (
                <tr key={vendor.vendorId}>
                  <td>
                    {vendor.photoURL ? (
                      <img
                        src={vendor.photoURL}
                        alt=""
                        className="event-thumb"
                      />
                    ) : (
                      <span
                        className="event-thumb inline-block bg-[var(--muted)]"
                        aria-hidden
                      />
                    )}
                  </td>
                  <td>
                    <strong className="text-[#121212]">
                      {vendor.vendorName}
                    </strong>
                  </td>
                  <td>{vendor.category || '—'}</td>
                  <td>{vendor.subcategory || '—'}</td>
                  <td>
                    <div className="manage-actions">
                      <Link
                        to={`/vendor/${vendor.vendorId}/view`}
                        className="bethere-action-btn"
                        title="View"
                        aria-label={`View ${vendor.vendorName}`}
                      >
                        <FontAwesomeIcon icon={['fas', 'eye']} />
                      </Link>
                      {canModify && (
                        <Link
                          to={`/vendor/${vendor.vendorId}`}
                          className="bethere-action-btn"
                          title="Edit"
                          aria-label={`Edit ${vendor.vendorName}`}
                        >
                          <FontAwesomeIcon icon={['fas', 'pen-to-square']} />
                        </Link>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {total > 0 && (
        <div className="section-header-bethere mt-6 flex flex-wrap items-center justify-between gap-4">
          <p className="m-0 text-sm text-[var(--muted-foreground)]">
            Showing 1 to {total} of {total} Vendors
          </p>
        </div>
      )}
    </>
  );
}
